import { CellQuantity } from 'vendor/pages/Private/@v2/OrderMaterials/components/cells/cell_quantity'

import { CellVendorNote } from 'vendor/pages/Private/@v2/OrderMaterials/components/cells/cell_vendor_note'

export const VendorOrderMaterialsCells = {
  Quantity: CellQuantity,
  VendorNote: CellVendorNote,
}
